import brand from '@helpers/brand';
import { cssVar, setCssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { ReactComponent as SvgFooterToggle } from '@img/icons/footer-toggle.svg';
import { m } from 'framer-motion';
import styled, { css } from 'styled-components';
const Header = styled(m.button) `
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  cursor: pointer;
  flex-direction: row;
  margin: 0 0 5px;
  padding: 0;

  @media ${from(Device.TabletLarge)} {
    align-items: flex-start;
    pointer-events: none;
    margin: 0 0 20px;
    text-align: left;
  }
`;
const Title = styled.p `
  ${fonts.sourceSansPro.semiBold}
  font-size: 18px;
  line-height: 32px;
  color: ${cssVar('fgColor')};

  @media ${from(Device.Tablet)} {
    font-size: 20px;
    line-height: 34px;
  }

  .theme-rss & {
    text-transform: uppercase;
  }
`;
const Toggle = styled(m.div) `
  margin-left: 10px;

  color: ${cssVar('fgColor')};

  @media ${from(Device.TabletLarge)} {
    display: none;
  }
`;
const ToggleIcon = styled(SvgFooterToggle) `
  display: block;
  height: 9px;
  width: 13px;
`;
const List = styled(m.ul) `
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  user-select: none;

  @media ${from(Device.TabletLarge)} {
    align-items: flex-start;
  }
`;
const Item = styled.li `
  margin-bottom: 16px;
`;
const Link = styled.a `
  ${fonts.sourceSansPro.regular};
  color: ${cssVar('fgColor')};
  font-size: 16px;
  line-height: 28px;
  text-decoration: none;

  @media ${from(Device.Tablet)} {
    font-size: 18px;
    line-height: 30px;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;
const Container = styled(m.nav) `
  ${setCssVar('bgColor', brand.grey)};
  ${setCssVar('fgColor', brand.white)};
  ${setCssVar('fgColorAlt', brand.hta.greenLight)};
  display: flex;
  align-items: center;
  flex-direction: column;
  user-select: none;

  @media ${from(Device.TabletLarge)} {
    align-items: flex-start;
  }

  .theme-apl & {
    ${setCssVar('bgColor', brand.white)};
    ${setCssVar('fgColor', brand.black)};
    ${setCssVar('fgColorAlt', brand.apl.green)};
  }

  ${({ mobileAccordion }) => !mobileAccordion &&
    css `
      ${Toggle} {
        display: none;
      }
    `}
`;
export default {
    Container,
    Header,
    Item,
    Link,
    List,
    Title,
    Toggle,
    ToggleIcon,
};
